import type { VoidFunctionComponent } from 'react';
import Header from '../../../shared/settings/SettingsPageHeader';
import PageContent from '../shared/SettingsPageContent';
import DropdownButton from '../../../generic/DropdownButton';
import useProjectUpdateHooksSettings, { hookTypeToLabelMap } from './useProjectUpdateHooksSettings';
import ProvidedBuildMessage from './ProvidedBuildMessage';
import UpdateHookConfig from './UpdateHookConfig';
import Redirect from '../../../generic/Redirect';

/**
 * ProjectUpdateHooksSettingsContainer
 */
const ProjectUpdateHooksSettingsContainer: VoidFunctionComponent = () => {
  const {
    locator,
    isProvidedProject,
    updateHook,
    hookType,
    onUpdateHookType,
    hookTypeOptions,
    onUpdate,
    onSave,
    isSaving,
    isSaveButtonDisabled,
    canUserEditSettings,
    projectSettingsBaseURL,
    vcsHost,
  } = useProjectUpdateHooksSettings();

  if (!canUserEditSettings) {
    return (
      <Redirect to={projectSettingsBaseURL} />
    );
  }

  return (
    <PageContent>
      <Header heading="Update Hooks">
        <Header.SaveButton
          onClick={onSave}
          isLoading={isSaving}
          isDisabled={isSaveButtonDisabled}
        />
      </Header>
      {isProvidedProject ? <ProvidedBuildMessage /> : (
        <>
          {hookTypeOptions.length > 0 && (
            //  Note that this should never actually be empty, but if it is it means that
            //  this project is not a valid project type for automatic updates and we shouldn't render this.
            <div className="margin-bottom-sm">
              <DropdownButton
                id="project-update-hook-type-dropdown"
                title={hookType ? hookTypeToLabelMap[hookType] : 'No Automatic Updates'}
                onSelect={onUpdateHookType}
                size="large"
              >
                {hookTypeOptions.map(({ value, label }) => (
                  <DropdownButton.Item key={value} eventKey={value}>
                    {label as string}
                  </DropdownButton.Item>
                ))}
              </DropdownButton>
            </div>
          )}
          <UpdateHookConfig
            locator={locator}
            isSaving={isSaving}
            hookType={hookType}
            updateHook={updateHook}
            onUpdate={onUpdate}
            vcsHost={vcsHost}
          />
        </>
      )}
    </PageContent>
  );
};

export default ProjectUpdateHooksSettingsContainer;
